import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs';

import { useTemplateMessageCategoriesQuery } from '@/types/graphql';

const DynamicCategoryBreadcrumbs = (props: BreadcrumbComponentProps) => {
  const category = useTemplateMessageCategoriesQuery({
    variables: {
      input: {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: props.match.params.categoryId!,
      },
    },
    skip: props.match.params.categoryId == null,
  });

  return <>{category.data?.templateMessageCategories[0].name}</>;
};

export default DynamicCategoryBreadcrumbs;
